import ResultOptionCard from '../ResultOptionCard'

const ResultsContainer = ({ tips, onClickResult }) => {
  return (
    <div className="flex items-stretch overflow-x-auto bg-transparent -mb-3 pl-8">
      {tips.map((tip) => (
        <div key={tip.id} className="pb-3 pr-8">
          <ResultOptionCard option={tip} onClick={onClickResult} imageMode='contain' />
        </div>
      ))}
    </div>
  )
}

export default ResultsContainer
